import { Color } from "@adoptaunabuelo/react-components";
import { Landmark } from "lucide-react";

const SvgBack = (props: Props) => {
	switch (props.brand) {
		case "visa":
			return (
				<svg
					style={{ backgroundColor: "#26337A", ...props.style }}
					viewBox="0 0 100 60"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g
						id="Payment-badge-set"
						stroke="none"
						strokeWidth="1"
						fill="none"
						fillRule="evenodd"
					>
						<g
							id="Dark-Payment-badges"
							transform="translate(-130.000000, -164.000000)"
						>
							<g
								id="Visa-dark"
								transform="translate(130.000000, 164.000000)"
							>
								<rect
									id="Rectangle"
									fill="#26337A"
									x="0"
									y="0"
									width="100"
									height="60"
									rx="4"
								></rect>
								<polyline
									id="Fill-3"
									fill="#FFFFFE"
									points="41.4899908 39.5467606 44.5647281 20.4726761 49.4795853 20.4726761 46.405129 39.5467606 41.4899908 39.5467606"
								></polyline>
								<path
									d="M64.232871,20.9408451 C63.2610876,20.5580282 61.7327143,20.1405634 59.8287834,20.1405634 C54.9695853,20.1405634 51.5490876,22.7290141 51.5206959,26.435493 C51.4897742,29.1771831 53.9615392,30.7061972 55.8249908,31.6174648 C57.7401659,32.5515493 58.3836175,33.1492958 58.3760276,33.984507 C58.3628157,35.2619718 56.8473733,35.8473239 55.4342535,35.8473239 C53.4665115,35.8473239 52.4210783,35.5591549 50.8047189,34.8470423 L50.1725115,34.5433803 L49.4852074,38.8129577 C50.6312765,39.3442254 52.7558756,39.8053521 54.960871,39.8295775 C60.1250691,39.8295775 63.4806313,37.2723944 63.5199862,33.3143662 C63.5376959,31.1402817 62.228023,29.4923944 59.3916636,28.131831 C57.674106,27.2473239 56.6199585,26.6614085 56.6320461,25.7661972 C56.6331705,24.9735211 57.5225899,24.1247887 59.4476037,24.1247887 C61.0552488,24.0988732 62.2190276,24.4701408 63.1258756,24.8577465 L63.567212,25.0757746 L64.232871,20.9408451"
									id="Fill-4"
									fill="#FFFFFE"
								></path>
								<path
									d="M70.7772995,32.7842254 C71.1846221,31.6878873 72.7352028,27.4526761 72.7352028,27.4526761 C72.70653,27.5030986 73.1402765,26.3478873 73.3884931,25.6329577 L73.7201982,27.2780282 C73.7201982,27.2780282 74.6633088,31.8307042 74.857553,32.7842254 L70.7772995,32.7842254 L70.7772995,32.7842254 Z M76.8407558,20.4921127 L73.0424516,20.4921127 C71.8643364,20.4921127 70.9825069,20.8295775 70.4663963,22.0732394 L63.1674793,39.5535211 L68.3297097,39.5535211 C68.3297097,39.5535211 69.1719032,37.2019718 69.3630553,36.6859155 C69.9261106,36.6859155 74.9421659,36.6957746 75.6581429,36.6957746 C75.8054424,37.3614085 76.2566175,39.5535211 76.2566175,39.5535211 L80.8184055,39.5535211 L76.8407558,20.4921127 L76.8407558,20.4921127 Z"
									id="Fill-5"
									fill="#FFFFFE"
								></path>
								<path
									d="M37.3667281,20.4887324 L32.5561613,33.4926761 L32.040894,30.8492958 C31.144447,27.803662 28.3539078,24.5025352 25.2325069,22.8484507 L29.6335023,39.5301408 L34.8350876,39.5270423 L42.5750599,20.4887324 L37.3667281,20.4887324"
									id="Fill-6"
									fill="#FFFFFE"
								></path>
								<path
									d="M28.0905115,20.4757746 L20.1647281,20.4757746 L20.0995115,20.8709859 C26.2666959,22.4509859 30.3472304,26.2647887 32.040894,30.8492958 L30.3185576,22.0850704 C30.0214286,20.876338 29.157871,20.5180282 28.0905115,20.4757746"
									id="Fill-7"
									fill="#EC982D"
								></path>
							</g>
						</g>
					</g>
				</svg>
			);
		case "mastercard":
			return (
				<svg
					style={{ backgroundColor: "black", ...props.style }}
					viewBox="0 0 36 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z"
						fill="black"
					/>
					<path
						d="M16.7615 11.635C17.0166 11.38 17.2866 11.1449 17.5641 10.9249C14.0313 8.13967 8.89582 8.37469 5.63552 11.635C2.12019 15.1503 2.12019 20.8483 5.63552 24.3637C8.89332 27.6215 14.0288 27.859 17.5616 25.0737C17.2841 24.8537 17.0141 24.6187 16.759 24.3637C13.2437 20.8483 13.2437 15.1503 16.759 11.635H16.7615Z"
						fill="#EB001B"
					/>
					<path
						d="M29.4901 11.6354C26.2323 8.37755 21.0968 8.14003 17.564 10.9253C17.8415 11.1453 18.1115 11.3803 18.3665 11.6354C21.8819 15.1507 21.8819 20.8487 18.3665 24.364C18.1115 24.6191 17.8415 24.8566 17.564 25.0741C21.0968 27.8594 26.2323 27.6218 29.4901 24.364C33.0054 20.8487 33.0054 15.1507 29.4901 11.6354Z"
						fill="#F79E1B"
					/>
					<path
						d="M21.0026 18.0006C21.0026 15.1304 19.6575 12.5751 17.5648 10.9275C15.4721 12.5751 14.127 15.1304 14.127 18.0006C14.127 20.8709 15.4721 23.4261 17.5648 25.0738C19.6575 23.4261 21.0026 20.8709 21.0026 18.0006Z"
						fill="#FF5F00"
					/>
				</svg>
			);
		case "amex":
			return (
				<svg
					style={{ backgroundColor: "#1D71B9", ...props.style }}
					viewBox="0 0 36 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z"
						fill="#1D71B9"
					/>
					<path
						d="M26.5671 13.4182L25.8705 14.9538H27.2674L26.5671 13.4182ZM18.5292 14.3698C18.6605 14.3074 18.7378 14.1719 18.7378 14.0036C18.7378 13.8386 18.6566 13.7191 18.5253 13.663C18.4057 13.6008 18.2218 13.5936 18.0453 13.5936H16.7992V14.4492H18.0286C18.2255 14.4492 18.3901 14.4466 18.5292 14.3698ZM2.56099 13.4182L1.87232 14.9538H3.25382L2.56099 13.4182ZM34.6248 23.2554H32.6704V22.4292H34.6169C34.8098 22.4292 34.945 22.4062 35.0264 22.3337C35.1033 22.2692 35.1468 22.1779 35.146 22.0825C35.146 21.9703 35.097 21.8811 35.0223 21.8278C34.949 21.769 34.842 21.7422 34.6657 21.7422C33.7155 21.7128 32.53 21.7689 32.53 20.5497C32.53 19.991 32.92 19.4028 33.9821 19.4028H35.998V18.6362H34.125C33.5598 18.6362 33.1491 18.7593 32.8584 18.9509V18.6362H30.0881C29.6451 18.6362 29.1251 18.7361 28.8792 18.9509V18.6362H23.9319V18.9509C23.5382 18.6925 22.8738 18.6362 22.5673 18.6362H19.3041V18.9509C18.9927 18.6765 18.2998 18.6362 17.8778 18.6362H14.2257L13.3901 19.459L12.6074 18.6362H7.15188V24.0125H12.5045L13.3655 23.1765L14.1766 24.0125L17.476 24.0151V22.7504H17.8004C18.2382 22.7568 18.7545 22.7406 19.2101 22.5615V24.0123H21.9315V22.611H22.0628C22.2302 22.611 22.2468 22.6174 22.2468 22.7697V24.012H30.5141C31.039 24.012 31.5876 23.8899 31.8914 23.6679V24.012H34.5138C35.0594 24.012 35.5924 23.9424 35.9978 23.7643V22.7628C35.7521 23.0898 35.273 23.2554 34.6248 23.2554ZM17.8438 21.9859H16.581V23.2782H14.614L13.3678 22.0028L12.0728 23.2782H8.06404V19.4255H12.1344L13.3795 20.6884L14.6668 19.4255H17.9006C18.7037 19.4255 19.6061 19.6278 19.6061 20.6947C19.6061 21.765 18.7284 21.9859 17.8438 21.9859ZM23.9159 21.8112C24.0589 21.9993 24.0795 22.1748 24.0836 22.5145V23.2782H23.0675V22.7963C23.0675 22.5645 23.0921 22.2212 22.9039 22.0421C22.7562 21.9041 22.5307 21.8712 22.1614 21.8712H21.0799V23.2782H20.0631V19.4255H22.3994C22.912 19.4255 23.285 19.4462 23.6172 19.6073C23.9366 19.7828 24.1376 20.0233 24.1376 20.4629C24.1375 21.0778 23.6867 21.3914 23.4203 21.4879C23.6454 21.5634 23.8295 21.699 23.9159 21.8112ZM28.0964 20.2223H25.7265V20.9227H28.0385V21.7088H25.7265V22.4753L28.0964 22.4788V23.2782H24.7187V19.4255H28.0964V20.2223ZM30.6969 23.2781H28.7259V22.452H30.6891C30.8811 22.452 31.0172 22.4289 31.1025 22.3565C31.1721 22.297 31.2221 22.2103 31.2221 22.1054C31.2221 21.9931 31.1679 21.9039 31.0986 21.8505C31.0211 21.7917 30.9143 21.7651 30.7382 21.7651C29.7917 21.7356 28.6065 21.7916 28.6065 20.5725C28.6065 20.0137 28.9924 19.4255 30.0534 19.4255H32.0824V20.2454H30.2258C30.0418 20.2454 29.9221 20.2518 29.8204 20.3152C29.7094 20.3776 29.6683 20.4701 29.6683 20.5922C29.6683 20.7375 29.7625 20.8365 29.8897 20.8792C29.9965 20.913 30.1111 20.9229 30.2836 20.9229L30.8284 20.9364C31.3776 20.9484 31.7549 21.035 31.9842 21.2462C32.1811 21.4316 32.2869 21.6659 32.2869 22.0624C32.2868 22.8912 31.7176 23.2781 30.6969 23.2781ZM22.8479 20.2844C22.7256 20.2183 22.5451 20.2148 22.365 20.2148H21.1188V21.0801H22.3484C22.5452 21.0801 22.7126 21.0737 22.8479 21.0007C22.979 20.9285 23.0575 20.7957 23.0575 20.6309C23.0575 20.4661 22.979 20.3468 22.8479 20.2844ZM34.1553 20.2147C33.9713 20.2147 33.8488 20.2211 33.7458 20.2843C33.639 20.3468 33.598 20.4393 33.598 20.5615C33.598 20.7068 33.6881 20.8057 33.8193 20.8486C33.9261 20.8823 34.0406 20.8922 34.2092 20.8922L34.7578 20.9055C35.3112 20.918 35.6808 21.0046 35.9061 21.2158C35.9472 21.245 35.9718 21.278 36 21.311V20.2148L34.1553 20.2147ZM17.8788 20.2147H16.5593V21.196H17.8671C18.2559 21.196 18.4977 21.0204 18.4979 20.6871C18.4977 20.3502 18.2442 20.2147 17.8788 20.2147ZM9.07201 20.2147V20.9152H11.2937V21.7013H9.07201V22.4678H11.5602L12.7162 21.3375L11.6093 20.2147H9.07201ZM15.5692 22.909V19.8202L14.0155 21.3397L15.5692 22.909ZM9.15694 16.7232V17.3871H17.612L17.6081 15.9827H17.7717C17.8863 15.9863 17.9197 15.9959 17.9197 16.168V17.3871H22.2927V17.0601C22.6455 17.2321 23.194 17.3871 23.9159 17.3871H25.7557L26.1494 16.5316H27.0223L27.4073 17.3871H30.9526V16.5744L31.4893 17.3871H34.3303V12.0151H31.5188V12.6496L31.1251 12.0151H28.2401V12.6496L27.8786 12.0151H23.9816C23.3292 12.0151 22.7559 12.098 22.2927 12.3288V12.0151H19.6033V12.3288C19.3086 12.0909 18.9069 12.0151 18.4605 12.0151H8.63548L7.9763 13.4027L7.2993 12.0151H4.20475V12.6496L3.86473 12.0151H1.2256L4.61549e-05 14.5694V16.6125L1.81227 12.7606H3.31595L5.03706 16.4075V12.7606H6.6889L8.01331 15.3736L9.23005 12.7606H10.915V16.6125H9.87769L9.87391 13.5958L8.40637 16.6125H7.51779L6.04651 13.5931V16.6125H3.98801L3.59916 15.7533H1.492L1.09913 16.6125H4.61549e-05L0 17.3874H1.72924L2.11911 16.5318H2.99208L3.38093 17.3874H6.78315V16.7332L7.0868 17.3901H8.85296L9.15694 16.7232ZM22.4805 13.2096C22.8075 12.9022 23.3199 12.7604 24.0173 12.7604H24.9971V13.5857H24.0379C23.6687 13.5857 23.46 13.6357 23.2592 13.814C23.0866 13.9761 22.9682 14.2827 22.9682 14.6864C22.9682 15.0991 23.0585 15.3966 23.2464 15.591C23.4023 15.7434 23.6855 15.7896 23.9518 15.7896H24.4065L25.8328 12.7605H27.3491L29.0626 16.4038V12.7606H30.6035L32.3824 15.4432V12.7606H33.4191V16.6123H31.9849L30.0667 13.7213V16.6123H28.0056L27.6118 15.7531H25.5094L25.1273 16.6123H23.943C23.4511 16.6123 22.8283 16.5134 22.4756 16.1863C22.1199 15.8592 21.935 15.4162 21.935 14.7158C21.9348 14.1445 22.0453 13.6223 22.4805 13.2096ZM20.3988 12.7605H21.4314V16.6123H20.3988V12.7605ZM15.7432 12.7605H18.0709C18.5879 12.7605 18.9692 12.7729 19.2964 12.9449C19.6165 13.117 19.8085 13.3682 19.8085 13.7978C19.8085 14.412 19.3579 14.7292 19.0955 14.8245C19.3169 14.9012 19.5061 15.0367 19.5962 15.1489C19.7391 15.3405 19.7637 15.5116 19.7637 15.8556V16.6123H18.743L18.7392 16.1265C18.7392 15.8947 18.7636 15.5614 18.5795 15.3762C18.4316 15.2408 18.2062 15.2113 17.8418 15.2113H16.7554V16.6123H15.7433L15.7432 12.7605ZM11.6634 12.7605H15.0442V13.5626H12.6756V14.2569H14.9874V15.0464H12.6756V15.8157H15.0442V16.6123H11.6634V12.7605Z"
						fill="white"
					/>
				</svg>
			);
		case "paypal":
			return (
				<svg
					style={{ ...props.style }}
					height="32px"
					width="32px"
					version="1.1"
					id="Capa_1"
					x="0px"
					y="0px"
					viewBox="0 0 512 512"
				>
					<path
						style={{ fill: "#92DBEF" }}
						d="M512,402.282c0,16.716-13.55,30.267-30.265,30.267H30.265C13.55,432.549,0,418.997,0,402.282V109.717
                    c0-16.716,13.55-30.266,30.265-30.266h451.47c16.716,0,30.265,13.551,30.265,30.266V402.282L512,402.282z"
					/>
					<path
						style={{ opacity: 0.15, fill: "#202121" }}
						d="M21.517,402.282V109.717
                    c0-16.716,13.552-30.266,30.267-30.266h-21.52C13.55,79.451,0,93.001,0,109.717v292.565c0,16.716,13.55,30.267,30.265,30.267h21.52
                    C35.07,432.549,21.517,418.997,21.517,402.282z"
					/>
					<path
						style={{ fill: "#263B80" }}
						d="M332.435,148.47c-11.22-12.825-32.057-19.233-60.905-19.233h-80.143
                    c-4.811,0-9.616,4.812-11.22,9.613L148.11,348.817c0,4.815,3.207,8.014,6.407,8.014h49.687l12.823-78.534v3.206
                    c1.606-4.813,6.409-9.615,11.222-9.615h24.045c46.479,0,81.733-19.233,92.955-72.132v-4.808c-1.602,0-1.602,0,0,0
                    C346.854,174.117,343.648,161.292,332.435,148.47"
					/>
					<path
						style={{ fill: "#232C65" }}
						d="M345.25,199.756v-4.808c0.011-0.159,0.018-0.307,0.028-0.465c-2.85-1.981-5.52-3.363-7.561-4.259
                    c-9.732-4.021-19.684-4.779-24.278-4.894l-0.024-0.02h-23.374c0,0,0.02,0.012,0.03,0.019h-49.03
                    c-8.336,0.303-10.634,7.024-11.236,9.948l-12.777,83.021v1.97v1.235c1.606-4.813,6.409-9.615,11.222-9.615h24.045
                    C298.774,271.888,334.028,252.654,345.25,199.756z"
					/>
					<path
						style={{ fill: "#139AD6" }}
						d="M360.996,214.814c-3.622-9.993-10.031-16.378-15.717-20.332c-0.011,0.158-0.018,0.306-0.028,0.465
                    v4.808c-11.222,52.898-46.476,72.132-92.955,72.132h-24.045c-4.813,0-9.616,4.801-11.222,9.615v-1.236
                    c-0.183,0.41-0.352,0.823-0.49,1.236l-9.055,55.247l-3.279,20.082h-0.012l-3.679,22.442c0,3.204,1.605,6.403,6.408,6.403h39.953
                    c8.038,0,10.563-6.253,11.339-9.622l0.339-2.093v-0.001l7.672-47.584c0,0,1-11.219,11.945-11.219h4.089
                    c40.07,0,72.126-16.025,80.139-64.107C364.626,237.645,364.516,225.032,360.996,214.814z"
					/>
				</svg>
			);
		case "sepa_debit":
			return (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: 24,
						width: 42,
						borderRadius: 2,
						backgroundColor: Color.background.low,
						...props.style,
					}}
				>
					<Landmark height={18} width={18} />
				</div>
			);
		case "apple_pay":
			return (
				<svg
					style={{ backgroundColor: "#F0F3F6", ...props.style }}
					viewBox="0 0 36 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z"
						fill="#F0F3F6"
					/>
					<path
						d="M27.9078 24.2463C29.2905 24.2463 29.9413 23.7187 30.5097 22.1195L33 15.1348H31.5582L29.8882 20.5386H29.8589L28.189 15.1421H26.7063L29.1087 21.7902L28.98 22.1946C28.8892 22.7734 28.3695 23.1863 27.7846 23.1436C27.673 23.1436 27.4565 23.132 27.3686 23.1204V24.2183C27.5474 24.2427 27.7279 24.2543 27.9078 24.2536V24.2463ZM23.1029 20.7485C22.3466 20.7485 21.8666 20.3825 21.8666 19.8287C21.8666 19.2548 22.3295 18.9205 23.2145 18.8675L24.7905 18.7681V19.2841C24.7558 20.1343 24.0379 20.796 23.1877 20.7613C23.159 20.76 23.131 20.7576 23.1029 20.7552V20.7485ZM22.7223 21.8323C23.5805 21.8555 24.3831 21.4084 24.8143 20.6661H24.8436V21.764H26.1561V17.217C26.1561 15.8984 25.1016 15.0488 23.478 15.0488C21.9721 15.0488 20.8584 15.91 20.8175 17.0938H22.0953C22.2478 16.4919 22.8199 16.0948 23.4371 16.1619C24.3044 16.1619 24.7905 16.5663 24.7905 17.3104V17.8142L23.0218 17.9197C21.375 18.0191 20.4845 18.693 20.4845 19.8653C20.4833 21.054 21.4031 21.839 22.7217 21.839L22.7223 21.8323ZM15.1161 13.8223H16.7506C17.9814 13.8223 18.6847 14.4785 18.6847 15.6331C18.6847 16.7877 17.9814 17.4494 16.7451 17.4494H15.1161V13.8223ZM13.698 12.6268V21.7621H15.1161V18.6479H17.0794C18.6786 18.7339 20.0442 17.5074 20.1302 15.9082C20.1351 15.8173 20.1357 15.727 20.132 15.6361C20.2076 14.0546 18.9872 12.7116 17.4057 12.6354C17.3124 12.6311 17.2197 12.6317 17.1263 12.636L13.698 12.6268ZM8.99128 14.3315C8.17644 14.2846 7.4793 14.7945 7.09262 14.7945C6.70593 14.7945 6.10821 14.3553 5.46353 14.3675C4.60965 14.3895 3.8314 14.8622 3.41848 15.6099C2.5396 17.1219 3.18977 19.3603 4.03938 20.5905C4.45534 21.2004 4.95425 21.8683 5.60991 21.8445C6.23081 21.8213 6.47721 21.4401 7.22741 21.4401C7.9776 21.4401 8.20022 21.8445 8.85649 21.8323C9.53594 21.8207 9.9641 21.2224 10.3813 20.6124C10.6753 20.1806 10.904 19.7079 11.0607 19.2096C10.2599 18.8596 9.74087 18.0709 9.7366 17.1969C9.7488 16.426 10.1526 15.7148 10.8088 15.3105C10.3904 14.7164 9.71891 14.3517 8.9925 14.3261L8.99128 14.3315ZM8.48261 13.5246C8.12581 13.9741 7.57994 14.2321 7.00601 14.2218C6.96941 13.6619 7.15971 13.1111 7.53359 12.6927C7.90563 12.2609 8.43016 11.9901 8.99738 11.937C9.03764 12.5128 8.85283 13.0812 8.48139 13.5228"
						fill="black"
					/>
				</svg>
			);
		case "google_pay":
			return (
				<svg
					style={{ backgroundColor: "#F0F3F6", ...props.style }}
					viewBox="0 0 36 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z"
						fill="#F0F3F6"
					/>
					<path
						d="M17.1879 18.2064V21.6742H16.0801V13.1102H19.0182C19.3689 13.1029 19.7176 13.1647 20.0441 13.2919C20.3706 13.4192 20.6686 13.6094 20.9207 13.8516C21.1754 14.0791 21.3781 14.3581 21.5152 14.6698C21.6522 14.9816 21.7205 15.3188 21.7154 15.659C21.7227 16.0009 21.6555 16.3404 21.5183 16.6541C21.3811 16.9678 21.1773 17.2484 20.9207 17.4766C20.4069 17.9631 19.7728 18.2061 19.0182 18.2057H17.1879V18.2064ZM17.1879 14.1646V17.1541H19.0457C19.2494 17.1601 19.4521 17.1238 19.6408 17.0475C19.8295 16.9713 20.0002 16.8568 20.1418 16.7113C20.2827 16.5752 20.3947 16.4126 20.4711 16.2328C20.5476 16.0531 20.587 15.8599 20.587 15.6648C20.587 15.4696 20.5476 15.2765 20.4711 15.0967C20.3947 14.917 20.2827 14.7543 20.1418 14.6183C20.002 14.4697 19.8319 14.3524 19.6429 14.2741C19.454 14.1957 19.2504 14.1582 19.0457 14.1639H17.1879V14.1646Z"
						fill="#5F6368"
					/>
					<path
						d="M24.2681 15.6233C25.0869 15.6233 25.7332 15.8406 26.2071 16.2752C26.6809 16.7098 26.9176 17.3056 26.9172 18.0627V21.6741H25.8575V20.8609H25.8094C25.3507 21.5306 24.7406 21.8654 23.9791 21.8654C23.3291 21.8654 22.7853 21.6741 22.3476 21.2914C22.1376 21.1158 21.9697 20.8958 21.8562 20.6476C21.7426 20.3993 21.6863 20.1291 21.6912 19.8564C21.6912 19.2501 21.922 18.7679 22.3834 18.4099C22.8449 18.0518 23.461 17.8723 24.2316 17.8714C24.8894 17.8714 25.4312 17.991 25.8568 18.2301V17.9787C25.8581 17.7928 25.8177 17.609 25.7385 17.4406C25.6594 17.2722 25.5435 17.1234 25.3993 17.005C25.1063 16.7425 24.7245 16.5993 24.33 16.6039C23.7112 16.6039 23.2215 16.8631 22.861 17.3815L21.8853 16.7713C22.422 16.0059 23.2162 15.6233 24.2681 15.6233ZM22.8348 19.8804C22.8341 20.0204 22.867 20.1585 22.9309 20.2833C22.9948 20.4081 23.0879 20.516 23.2022 20.5978C23.4472 20.7892 23.7514 20.8906 24.063 20.8848C24.5305 20.8841 24.9786 20.6993 25.3091 20.371C25.6761 20.0279 25.8596 19.6255 25.8596 19.1636C25.5142 18.8902 25.0325 18.7536 24.4146 18.7536C23.9646 18.7536 23.5894 18.8613 23.2889 19.0768C22.9855 19.2954 22.8348 19.5612 22.8348 19.8804Z"
						fill="#5F6368"
					/>
					<path
						d="M33 15.8147L29.3009 24.2571H28.1573L29.53 21.3031L27.0977 15.8147H28.3018L30.0598 20.0239H30.0839L31.7938 15.8147H33Z"
						fill="#5F6368"
					/>
					<path
						d="M12.7115 17.4586C12.7119 17.1234 12.6833 16.7887 12.6261 16.4583H7.9541V18.3531H10.63C10.5753 18.6557 10.4594 18.9442 10.2893 19.2012C10.1193 19.4581 9.89859 19.6782 9.64058 19.8482V21.0782H11.2376C12.1727 20.222 12.7115 18.9558 12.7115 17.4586Z"
						fill="#4285F4"
					/>
					<path
						d="M7.95375 22.2666C9.29069 22.2666 10.4164 21.8306 11.2373 21.079L9.64023 19.849C9.19573 20.1483 8.62325 20.3191 7.95375 20.3191C6.66154 20.3191 5.56474 19.4541 5.17254 18.2883H3.52734V19.5559C3.93969 20.3707 4.57197 21.0557 5.3536 21.5344C6.13523 22.013 7.03545 22.2666 7.95375 22.2666Z"
						fill="#34A853"
					/>
					<path
						d="M5.17273 18.2885C4.96538 17.6776 4.96538 17.0161 5.17273 16.4052V15.1377H3.52753C3.18065 15.8232 3 16.5797 3 17.3469C3 18.114 3.18065 18.8705 3.52753 19.556L5.17273 18.2885Z"
						fill="#FBBC04"
					/>
					<path
						d="M7.95375 14.3743C8.66026 14.3628 9.34294 14.6279 9.85422 15.1123L11.2682 13.7081C10.3716 12.8717 9.18377 12.4126 7.95375 12.4268C7.03545 12.4269 6.13523 12.6804 5.3536 13.1591C4.57197 13.6377 3.93969 14.3227 3.52734 15.1376L5.17254 16.4051C5.56474 15.2394 6.66154 14.3743 7.95375 14.3743Z"
						fill="#EA4335"
					/>
				</svg>
			);
		case "apple_pay_button":
			return (
				<svg
					width="46"
					height="21"
					viewBox="0 0 46 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					style={props.style}
				>
					<path
						d="M8.58397 3.21748C9.11997 2.54936 9.48234 1.651 9.38797 0.72998C8.60662 0.767727 7.64786 1.24711 7.09676 1.91522C6.5985 2.48897 6.16064 3.42508 6.27388 4.30458C7.15338 4.38007 8.03287 3.86672 8.58397 3.2137"
						fill="white"
					/>
					<path
						d="M9.37687 4.47817C8.10104 4.40268 7.01394 5.2029 6.40622 5.2029C5.7985 5.2029 4.86239 4.51592 3.85455 4.53479C2.54098 4.55366 1.32176 5.29727 0.653649 6.47873C-0.71655 8.84167 0.291282 12.3483 1.62373 14.2772C2.27298 15.2284 3.05055 16.2777 4.08103 16.24C5.05112 16.2022 5.43236 15.6096 6.61383 15.6096C7.79529 15.6096 8.13879 16.24 9.16549 16.2211C10.2337 16.2022 10.8981 15.2661 11.5473 14.3149C12.2909 13.2278 12.5929 12.1822 12.6155 12.1218C12.5967 12.103 10.5583 11.3216 10.5395 8.97756C10.5206 7.01474 12.1399 6.0824 12.2154 6.022C11.3019 4.67068 9.87135 4.51592 9.37687 4.47817Z"
						fill="white"
					/>
					<path
						d="M20.4899 1.8208C23.2643 1.8208 25.1969 3.73455 25.1969 6.51647C25.1969 9.29839 23.2265 11.2348 20.4219 11.2348H17.3494V16.1192H15.1299V1.8208H20.4899ZM17.3494 9.37388H19.8973C21.8299 9.37388 22.9283 8.33208 22.9283 6.53157C22.9283 4.73106 21.8299 3.6968 19.9048 3.6968H17.3494V9.37388Z"
						fill="white"
					/>
					<path
						d="M25.7782 13.1599C25.7782 11.3367 27.1748 10.2157 29.6548 10.076L32.5084 9.90613V9.10213C32.5084 7.94331 31.727 7.24877 30.4172 7.24877C29.1791 7.24877 28.4053 7.84139 28.2166 8.77373H26.1934C26.3104 6.89018 27.9184 5.50488 30.4927 5.50488C33.067 5.50488 34.6335 6.84111 34.6335 8.93227V16.1154H32.5839V14.4017H32.5348C31.9309 15.5606 30.6135 16.2928 29.2433 16.2928C27.2012 16.2928 25.7744 15.0246 25.7744 13.1523L25.7782 13.1599ZM32.5084 12.22V11.3971L29.9416 11.5557C28.662 11.6462 27.9411 12.2087 27.9411 13.1033C27.9411 13.9979 28.696 14.6093 29.8435 14.6093C31.3383 14.6093 32.5084 13.5789 32.5084 12.22Z"
						fill="white"
					/>
					<path
						d="M36.5734 19.958V18.2255C36.732 18.2632 37.0868 18.2632 37.268 18.2632C38.2607 18.2632 38.7929 17.848 39.1213 16.776C39.1213 16.7571 39.3101 16.1418 39.3101 16.1305L35.543 5.6936H37.8606L40.4953 14.1752H40.5331L43.1678 5.6936H45.4288L41.5258 16.6627C40.635 19.1918 39.6045 20.0033 37.4416 20.0033C37.2642 20.0033 36.7282 19.9844 36.5697 19.9542L36.5734 19.958Z"
						fill="white"
					/>
				</svg>
			);
		case "google_pay_button":
			return (
				<svg
					width="41"
					height="17"
					xmlns="http://www.w3.org/2000/svg"
					style={props.style}
				>
					<g fill="none" fillRule="evenodd">
						<path
							d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zm7.668 2.287c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568m11.853.262l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z"
							fill="#FFF"
						/>
						<path
							d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944"
							fill="#4285F4"
						/>
						<path
							d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703"
							fill="#34A853"
						/>
						<path
							d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z"
							fill="#FABB05"
						/>
						<path
							d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774"
							fill="#E94235"
						/>
					</g>
				</svg>
			);
		default:
			return (
				<svg
					style={props.style}
					width="36"
					height="36"
					viewBox="0 0 36 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_7696_16028)">
						<path
							d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z"
							fill="#F0F3F6"
						/>
						<path
							fillRule="evenodd"
							clip-rule="evenodd"
							d="M36 16L5.24537e-07 16L0 10L36 10L36 16Z"
							fill="#66839E"
						/>
						<rect
							x="20"
							y="20"
							width="12"
							height="6"
							rx="1"
							fill="#A6BACB"
						/>
					</g>
					<defs>
						<clipPath id="clip0_7696_16028">
							<path
								d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z"
								fill="white"
							/>
						</clipPath>
					</defs>
				</svg>
			);
	}
};

export default SvgBack;
export interface Props {
	brand?: string;
	style?: any;
}
